import React from "react";
import ExploreVillas from "../components/ExploreVillas";
import FeaturedProperties from "../components/FeaturedProperties";
import Header from "../components/header";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import BackToTop from "../components/BackToTop";
import ExperienceSection from "../components/ExperienceSection";
import HolidaySection from "../components/HolidaySection";
import WhatsappButton from "../components/WhatsappButton";
import { Helmet } from "react-helmet-async";
import "../assets/css/styles.css";

const Home = () => {
    return (
        <div className="lsq-site-container">
            <Helmet>
                <title>LSQ Stays - Luxury Vacation Rentals & Villas | Luxury Redefined</title>
                <meta name="description" content="Discover premium luxury vacation rentals and villas with LSQ Stays. Book exclusive properties in top destinations for your perfect getaway." />
                <link rel="canonical" href="https://www.lsqstays.in/" />
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "RealEstateAgent",
                        "name": "LSQ Stays",
                        "url": "https://www.lsqstays.in",
                        "logo": {
                            "@type": "ImageObject",
                            "url": "https://www.lsqstays.in/assets/Images/logo.png",
                            "width": 112,
                            "height": 112,
                            "contentUrl": "https://www.lsqstays.in/assets/Images/logo.png"
                        },
                        "image": "https://www.lsqstays.in/assets/Images/logo.png",
                        "description": "Luxury vacation rentals and villas for your perfect getaway.",
                        "address": {
                            "@type": "PostalAddress",
                            "addressLocality": "Mumbai",
                            "addressRegion": "Maharashtra",
                            "addressCountry": "India"
                        },
                        "telephone": "+91-89288-36738"
                    })}
                </script>
            </Helmet>
            <Header currentPage="home" />
            <Hero />
            <ExploreVillas />
            <HolidaySection />
            <FeaturedProperties />
            <ExperienceSection />
            <Footer />
            <BackToTop />
            <WhatsappButton />
        </div>
    );
}

export default Home;